import { useMemo, useState } from 'react';
import { Card } from '@astryxdesign/core/Card';
import { EmptyState } from '@astryxdesign/core/EmptyState';
import { Heading } from '@astryxdesign/core/Heading';
import { VStack } from '@astryxdesign/core/Layout';
import { List, ListItem } from '@astryxdesign/core/List';
import { SegmentedControl, SegmentedControlItem } from '@astryxdesign/core/SegmentedControl';
import { Text } from '@astryxdesign/core/Text';
import { useTenant } from '@/app/tenant-context.ts';
import { duration, money } from '@/lib/format.ts';
import { useOpenBooking } from '@/features/booking/nav.ts';
import { useIndustry } from '@/lib/industry.ts';

export function ServicesPage() {
  const { tenant } = useTenant();
  const copy = useIndustry();
  const openBooking = useOpenBooking();
  const categories = useMemo(() => [...new Set(tenant.services.map((s) => s.category).filter(Boolean))], [tenant.services]);
  const [cat, setCat] = useState('all');
  const list = tenant.services.filter((s) => cat === 'all' || s.category === cat);

  return (
    <VStack gap={4} padding={4}>
      <VStack gap={1} paddingBlockStart={4}>
        <Heading level={1}>Услуги и цены</Heading>
        <Text type="supporting">Нажмите на услугу, чтобы выбрать время.</Text>
      </VStack>
      {categories.length > 1 && (
        <SegmentedControl label="Категория" value={cat} onChange={setCat} size="sm">
          <SegmentedControlItem value="all" label="Все" />
          {categories.map((c) => (
            <SegmentedControlItem key={c} value={c} label={c} />
          ))}
        </SegmentedControl>
      )}
      {list.length === 0 ? (
        <EmptyState title="Услуг пока нет" description={copy.noServices} />
      ) : (
        <Card padding={1}>
          <List hasDividers>
            {list.map((s) => (
              <ListItem
                key={s.id}
                label={s.name}
                description={
                  <VStack gap={0.5}>
                    {s.description && <Text type="supporting">{s.description}</Text>}
                    <Text type="supporting">{duration(s.duration_minutes)}</Text>
                  </VStack>
                }
                endContent={<Text weight="semibold">{money(s.price_cents, tenant.currency, s.price_is_from)}</Text>}
                onClick={() => openBooking({ serviceId: s.id })}
              />
            ))}
          </List>
        </Card>
      )}
    </VStack>
  );
}
